// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ezcX","name":"Header_name__16fC0","birthday":"Header_birthday__1zCUv","skeleton":"Header_skeleton__3tWdb"};